<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../../Core/Card.svelte";
  import { Bar } from 'svelte-chartjs';
  import { BarChart } from "../../../utils/Constant/Constant";
  import { Chart, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
  import {BarChartData } from "../../../Data/Chart/Charts/ChartJs"
 
  Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
</script>
<Col xl="6" md="12" class="box-col-12">
    <Card headerTitle={BarChart} cardHeaderprops="pb-0" cardBodyprops="chart-block">
      <div slot="contentbody" >
        <Bar
          data={BarChartData}
          options={{maintainAspectRatio: true}}
          width={778}
          height={400} />
      </div>
    </Card>
</Col>